import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box, Grid, Typography } from "@mui/material";

// Components
import { userState, lastListCookieId, briefInfoType } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { CommonUtils } from "../../utils/common_utils";

// CSS
import "./Brief.css";
import "swiper/css";

interface propsType {
  image_list: any;
}

const unAuthAPI = new HttpUnAuthApi();
const cUtils = new CommonUtils();

const BriefSlider = (props: propsType) => {
//   const { pk, sk } = useParams();
//   const windowSize = useWindowSize();
//   const popScrapRef: any = useRef();

  const slideRef: any = useRef();
  const [selectedImage, setSelectedImage] = useState<string>();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0); // 현재 선택된 이미지의 인덱스
  const [isModalOpen, setIsModalOpen] = useState(false); // 모달 열림 상태

  const imgRef = useRef<HTMLImageElement | null>(null);
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);

  const [isAtStart, setIsAtStart] = useState(true); // 슬라이드가 처음에 있는지
  const [isAtEnd, setIsAtEnd] = useState(false);    // 슬라이드가 끝에 있는지

  // 슬라이드 변경 시 호출되는 함수
  const handleSlideChange = (swiper: any) => {
    const currentIndex = swiper.activeIndex;
    setIsAtStart(swiper.isBeginning);  // 슬라이드가 첫 번째면 true
    setIsAtEnd(swiper.isEnd);          // 슬라이드가 마지막이면 true
    setSelectedImage(props.image_list[currentIndex]);
  };
  
  // 화살표 클릭 시 이미지 변경
  const handlePrevClick = () => {
    if (slideRef.current) {
        slideRef.current.swiper.slidePrev();
        // handleSlideChange(slideRef.current.swiper);

        if (selectedImageIndex > 0) {
            setSelectedImageIndex(selectedImageIndex - 1);
        }
    }
  };

  const handleNextClick = () => {
        if (slideRef.current) {
            slideRef.current.swiper.slideNext();
            
            if ( props.image_list.length > 0 && selectedImageIndex < props.image_list.length - 1) {
                setSelectedImageIndex(selectedImageIndex + 1);
            }
            // handleSlideChange(slideRef.current.swiper);
        }
  };

  // 전체 보기 버튼 클릭 시 모달 열기
  const handleViewAllClick = () => {
    setIsModalOpen(true);
  };

  // 모달 외부 클릭 시 모달 닫기
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleImageLoad = () => {
    if (imgRef.current) {
      setImageWidth(imgRef.current.clientWidth); // 이미지가 로드된 후 너비 설정
      setImageHeight(imgRef.current.clientHeight);
    }
  };

  useEffect(() => {
    setSelectedImage(props.image_list[selectedImageIndex]);
  }, [selectedImageIndex]);

  useEffect(() => {
    window.scrollTo({
      top: 0, // 설정한 위치로 이동
      behavior: "smooth", // 부드럽게 스크롤
    });

    if (props.image_list.length > 0) {
        setSelectedImage(props.image_list[0]);
    }

  }, []);

  return (
    <>
      {/* 대표 이미지 */}
      {props.image_list.length > 0 ? (
        <>
        <Box sx={{ position: "relative", mb: 2 }}>
          <img
            src={selectedImage}
            alt="대표 이미지"
            style={{ 
              maxWidth: '420px', 
              maxHeight: '420px', 
              minWidth: '300px',
              minHeight: '300px',
              width: '20vw', /* 화면 너비의 30% */
              height: '20vw', /* 1:1 비율 유지 */
              objectFit: 'cover' 
            }}
          />
          
          {/* 전체 보기 버튼을 대표 이미지 오른쪽 위에 추가 */}
          <button
            onClick={handleViewAllClick}
            style={{
              position: 'absolute',
              top: '16px', // 위쪽 여백
              // left: '370px', // 오른쪽 여백
              right: '16px',
              // backgroundColor: 'rgba(255, 255, 255, 0.8)',
              border: 'none', 
              borderRadius: '5px',
              width: '32px',
              height: '32px',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src="/images/btn-full-screen.png" alt="" />
          </button>
          
          {/* 네비게이션 버튼 추가 */}
          {props.image_list.length > 1 &&
            <Box
              sx={{
                position: 'absolute',
                bottom: '16px',
                left: '16px',
                // right: '16px',
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                // justifyContent: 'space-between',
                // transform: 'translateY(-50%)',
                // zIndex: 10,
              }}
            >
              <button 
                className="swiper-button-prev" 
                onClick={handlePrevClick} 
                style={{ 
                  position: "initial",
                  backgroundColor: 'rgb(0, 0, 0)', 
                  border: 'none', 
                  borderRadius: '50px', 
                  padding: '8px', 
                  opacity: selectedImageIndex === 0 ? 0.5 : 1, 
                  cursor: 'pointer', 
                  maxWidth: '40px',
                  minWidth: '30px',
                  maxHeight: '40px',
                  minHeight: '30px',
                  width: '2vw', 
                  height: '2vw', 
                  transform: 'none' 
                }}
              >
                <img 
                  src="/images/icon-arr-prev.png" 
                  alt="" 
                  style={{ 
                    minWidth: "8px",
                    maxWidth: "10px",
                    minHeight: "13px",
                    maxHeight: "15px",
                    width: "0.8vw", 
                    height: "1.2vw" 
                  }}
                />
              </button>
              <button 
                className="swiper-button-next" 
                onClick={handleNextClick} 
                style={{ 
                  position: "initial",
                  backgroundColor: 'rgb(0, 0, 0)', 
                  border: 'none', 
                  borderRadius: '50px', 
                  padding: '8px', 
                  opacity: selectedImageIndex === props.image_list.length - 1 ? 0.5 : 1, 
                  cursor: 'pointer', 
                  maxWidth: '40px',
                  minWidth: '30px',
                  maxHeight: '40px',
                  minHeight: '30px',
                  width: '2vw', 
                  height: '2vw', 
                  left: "70px", 
                  transform: 'none' 
                }}
              >
                <img 
                  src="/images/icon-arr-next.png" 
                  alt="" 
                  style={{ 
                    minWidth: "8px",
                    maxWidth: "10px",
                    minHeight: "13px",
                    maxHeight: "15px",
                    width: "0.8vw", 
                    height: "1.2vw" 
                  }} 
                />
              </button>
            </Box>
          }
        </Box>

        <Box sx={{ maxWidth: '420px', minWidth: '300px', width: '20vw', overflow: 'hidden' }}> 
          {/* 슬라이더 영역을 감싸는 박스 */}
          {props.image_list.length > 1 && 
            <Swiper 
              ref={slideRef}
              spaceBetween={16}
              slidesPerView={"auto"}
              centeredSlides={false}  // 처음에는 슬라이드가 중앙에 오도록 설정
              slideToClickedSlide={true}  // 클릭한 슬라이드로 이동
              onSlideChange={handleSlideChange} // 슬라이드 변경 시 호출
              style={{ width: "100%" }}
            //   navigation
            >
              {props.image_list.map((image: string, index: number) => (
                <SwiperSlide 
                  key={index} 
                  style={{ 
                    borderRadius: "0px", 
                    minWidth: "70px",
                    maxWidth: "80px",
                    width: "5vw",
                    minHeight: "70px",
                    maxHeight: "80px",
                    height: "5vw",
                  }}
                >
                  <Box
                    // key={index}
                    onClick={() => setSelectedImageIndex(index)}
                    sx={{
                      // margin: '0 8px',
                      cursor: 'pointer',
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      src={image}
                      alt={`상품 이미지 ${index + 1}`}
                      style={{
                        objectFit: 'cover',
                        //   borderRadius: '4px',
                        //   border: selectedImage === image ? '2px solid #000' : 'none',
                        opacity: selectedImage === image ? 1 : 0.5, // 선택된 이미지만 불투명도 1
                      }}
                    />
                  </Box>
                </SwiperSlide>
              ))}
              {/* 왼쪽 그라데이션: 처음 슬라이드가 아니면 표시 */}
              {!isAtStart && <div className="swiper-gradient-left"></div>}

              {/* 오른쪽 그라데이션: 마지막 슬라이드가 아니면 표시 */}
              {!isAtEnd && <div className="swiper-gradient-right"></div>}
            </Swiper>
          }
        </Box>
        </>
        ) : (
          <Box sx={{ mb: 2 }}>
            <div className="img-wrap">
              <div 
                key='top-image-0' 
                style={{ 
                  maxWidth: '420px', 
                  maxHeight: '420px', 
                  minWidth: '300px',
                  minHeight: '300px',
                  width: '20vw', /* 화면 너비의 30% */
                  height: '20vw', /* 1:1 비율 유지 */
                  backgroundColor: "#ddd" 
                }}
              >
                <img src="/images/no-image.png" className="noImage" style={{ height: "auto" }} />
              </div>
            </div>
          </Box>
        )}

        {/* 전체 이미지 모달 */}
        {isModalOpen && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
            onClick={handleModalClose} // 모달 외부 클릭 시 닫기
          >
            <img
              src={selectedImage}
              ref={imgRef} 
              onLoad={handleImageLoad}
              alt="전체 이미지"
              style={{
                maxWidth: '85%',
                maxHeight: '85%',
              }}
            />
            
            {/* 전체 보기 버튼을 대표 이미지 오른쪽 위에 추가 */}
            <button
              onClick={handleModalClose}
              style={{
                position: 'absolute',
                top: `calc(50% - ${imageHeight / 2 - 24}px)`, // 위쪽 여백
                right: `calc(50% - ${imageWidth / 2 - 24}px)`, // 오른쪽 여백
                // backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: 'none',
                borderRadius: '5px',
                width: '32px',
                height: '32px',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src="/images/btn-minimize-screen.png" alt="" />
            </button>
            
            {/* 모달 내 화살표 추가 */}
            {props.image_list.length > 1 && 
              <>
              <Box
                sx={{
                  position: 'absolute',
                  left: `calc(50% - ${imageWidth / 2 + 40 + 35}px)`, // 왼쪽 여백
                  top: '50%', // 수직 중앙 정렬
                  transform: 'translateY(-50%)', // 수직 중앙 정렬을 위한 변환
                }}
              >
                <button
                  className="swiper-button-prev"
                  onClick={(e) => { e.stopPropagation(); handlePrevClick(); }}
                  style={{ backgroundColor: 'rgb(0, 0, 0)', border: 'none', borderRadius: '50px', padding: '8px', opacity: selectedImageIndex === 0 ? 0.5 : 1, cursor: 'pointer', width: '40px', height: '40px', transform: 'none' }}
                  disabled={selectedImageIndex === 0} // 첫 번째 이미지일 경우 비활성화
                >
                  <img src="/images/icon-arr-prev.png" alt="" style={{ width: "10px", height: "15px" }}/>
                </button>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  left: `calc(50% + ${imageWidth / 2 - 40 - 10}px)`, // 오른쪽 여백
                  top: '50%', // 수직 중앙 정렬
                  transform: 'translateY(-50%)', // 수직 중앙 정렬을 위한 변환
                }}
              >
                <button
                  className="swiper-button-next"
                  onClick={(e) => { e.stopPropagation(); handleNextClick(); }}
                  style={{ backgroundColor: 'rgb(0, 0, 0)', border: 'none', borderRadius: '50px', padding: '8px', opacity: selectedImageIndex === props.image_list.length - 1 ? 0.5 : 1, cursor: 'pointer', width: '40px', height: '40px', left: "70px", transform: 'none' }}
                  disabled={selectedImageIndex === props.image_list.length - 1} // 마지막 이미지일 경우 비활성화
                >
                  <img src="/images/icon-arr-next.png" alt="" style={{ width: "10px", height: "15px" }} />
                </button>
              </Box>
              </>
            }
          </Box>
        )}

      {/* <PopAddScrap ref={popScrapRef} userState={props.userState} selectedKeywords={[]} callback={(payload: any) => {}} /> */}
    </>
  );
};

export default BriefSlider;
